import { createTheme } from '@mui/material/styles';
import { siteColors } from './constants/colors';
import red from '@mui/material/colors/red';

const theme = createTheme({
  zIndex: {
    appBar: 3100
  },
  palette: {
    primary: { main: siteColors.Primary },
    secondary: { main: siteColors.Secondary },
    error: { main: red.A400 },
  },
  typography: {
    allVariants: {
      fontFamily: 'Gilroy'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          paddingTop: '9px',
          paddingBottom: '9px',
          paddingLeft: '20px',
          paddingRight: '20px',
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '1px',
          color: 'white',
          '&:hover': {
            filter: 'brightness(1)'
          }
        },
        contained: {
          borderRadius: '10px'
        },
        containedSecondary: {
          color: 'white',
          filter: 'brightness(1)',
          '&:hover': {
            backgroundColor: siteColors.Secondary,
            color: 'black'
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          color: siteColors.Secondary,
          width: 24,
          height: 24
        },
        track: {
          color: siteColors.Secondary,
          height: 10,
        },
        rail: {
          color: siteColors.Secondary,
          height: 10
        }
      }
    }
  }
});

export default theme;